"use client";

import { useState } from "react";
import IconArrowDown from "@/app/(components)/generics/Icons/IconArrowDown";
import Popover from "@/app/(components)/generics/Popover/Popover";
import PopoverContent from "@/app/(components)/generics/Popover/PopoverContent";
import PopoverTrigger from "@/app/(components)/generics/Popover/PopoverTrigger";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { CreditTier } from "@/app/types/billing/CreditTier";
import { UCreditOffer } from "@/app/utils/UCreditOffer";
import { UStyles } from "@/app/utils/UStyles";
import { VOLUME_MENU_POSITION } from "./Pricing.logic";
import styles from "./Pricing.module.css";

type Props = {
  lang: string;
  tiers: CreditTier[];
  selected: CreditTier;
  isAnnual: boolean;
  discountPercent: number;
  onSelect: (tier: CreditTier) => void;
};

export default function PricingVolume(props: Props) {
  const T = useT();
  const { lang, tiers, selected, isAnnual, discountPercent, onSelect } = props;
  const [isOpen, setIsOpen] = useState(false);

  const select = (tier: CreditTier) => {
    onSelect(tier);
    setIsOpen(false);
  };

  return (
    <Popover
      isVisible={isOpen}
      setIsVisible={setIsOpen}
      openAfterClick
      closeWhenClickOutside
      className={styles.volume}
    >
      <PopoverTrigger>
        <div className={styles.volumeTrigger}>
          <span className={styles.volumeValue}>
            {UCreditOffer.formatCredits(selected.credits, lang)}
          </span>
          <span className={styles.volumeUnit}>{T(TKey.HOME_MEIDLY_PRICING_VOLUME_LABEL)}</span>
          <span
            className={UStyles.classNames(
              styles.volumeChevron,
              isOpen ? styles.volumeChevronOpen : "",
            )}
          >
            <IconArrowDown />
          </span>
        </div>
      </PopoverTrigger>

      <PopoverContent className={styles.volumeMenuWrapper} position={VOLUME_MENU_POSITION}>
        <div className={styles.volumeMenu}>
          {tiers.map((tier) => (
            <button
              key={tier.credits}
              type="button"
              className={UStyles.classNames(
                styles.volumeOption,
                tier.credits === selected.credits ? styles.volumeOptionActive : "",
              )}
              onClick={() => select(tier)}
            >
              <span className={styles.volumeValue}>
                {UCreditOffer.formatCredits(tier.credits, lang)}
              </span>
              <span className={styles.volumePrice}>
                {`${UCreditOffer.monthlyPriceEur(tier, isAnnual, discountPercent)}€`}
              </span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
